import MicroModal from 'micromodal';

class Modal {
  constructor(element) {
    this.element = element;
  }

  init() {
    MicroModal.init({
      disableScroll: true,
      disableFocus: false,
      awaitOpenAnimation: true,
      awaitCloseAnimation: true,
    });
  }
}

const modal = {
  init() {
    const modalItems = document.querySelectorAll('[data-module="modal"]');

    if (modalItems) {
      modalItems.forEach((item) => {
        const modalItem = new Modal(item);
        modalItem.init();
      });
    }
  },
};

export default modal;
